export let authHost = process.env.REACT_APP_SABIA_URL;
export let authorizationURL = authHost + "/oauth/authorize/";
export let registrationURL =
  process.env.REACT_APP_REGISTRATION_SABIA_URL +
  "/cadastrar/?url_autorizacao=/oauth/authorize/";
export let clientID = process.env.REACT_APP_SABIA_CLIENT_ID;
export let redirectURI = process.env.REACT_APP_SABIA_CLIENT_REDIRECT_URI;
export let responseType = "token";
export let grantType = "implict";
export let resourceURL = authHost + "/api/perfil/dados/";
export let logoutURL = authHost + "/oauth/revoke_token/";

export var extractToken = function () {
  var match = window.location.hash.match(/access_token=(\w+)/);
  if (match != null) {
    return !!match && match[1];
  }
  return null;
};

export var extractScope = function () {
  var match = window.location.hash.match(/scope=(.*)/);
  if (match != null) {
    return match[1].split("+").join(" ");
  }
  return null;
};

export var extractDuration = function () {
  var match = window.location.hash.match(/expires_in=(\d+)/);

  if (match != null) {
    return Number(!!match && match[1]);
  }

  return 0;
};

export var Token = function (value, expirationTimeInSeconds, scope) {
  /* Atributos */

  var value = value;
  var startTime = new Date().getTime(); // O valor em milissegundos.
  var finishTime = new Date(startTime + expirationTimeInSeconds * 1000); // O objeto Date.
  var scope = scope;

  // Cria os cookies para o token, seu momento da expiração e seus escopos.

  if (!localStorage.getItem("sabiaToken")) {
    localStorage.setItem("sabiaToken", value);
  } else {
    value = localStorage.getItem("sabiaToken");
  }

  if (!localStorage.getItem("sabiaTokenExpirationTime")) {
    localStorage.setItem("sabiaTokenExpirationTime", finishTime);
  } else {
    finishTime = localStorage.getItem("sabiaTokenExpirationTime");
  }

  if (!localStorage.getItem("sabiaScope")) {
    localStorage.setItem("sabiaScope", scope);
  } else {
    scope = localStorage.getItem("sabiaScope");
  }
};

export function isValid(value) {
  if (localStorage.getItem("sabiaToken") && value != null) {
    return true;
  }
  return false;
}

export function revoke() {
  if (localStorage.getItem("sabiaToken")) {
    localStorage.removeItem("sabiaToken");
  }

  if (localStorage.getItem("sabiaTokenExpirationTime")) {
    localStorage.removeItem("sabiaTokenExpirationTime");
  }

  if (localStorage.getItem("sabiaScope")) {
    localStorage.removeItem("sabiaScope");
  }
}
